import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import { WarningContainer, WarningText } from './SummaryWarning.styles';

interface Props {
  'data-testid'?: string;
  warningText?: string;
  eventId?: string;
  warningState?: boolean;
}

export const SummaryWarning = ({
  warningText = 'The following items will be deleted',
  ...props
}: Props) => {
  const theme = useTheme();
  return (
    <WarningContainer {...props}>
      {props.warningState ? (
        <StyledIcon
          className={'uil uil-exclamation-triangle'}
          size="24px"
          color={theme.atlas.semantic.color.status.warning.default}
        />
      ) : (
        <StyledIcon
          className="uil uil-trash"
          size="24px"
          color={theme.atlas.semantic.color.action.destructive.hover}
        />
      )}
      <WarningText warningState={props.warningState}>
        {warningText}
        {props.eventId ? ' in Event ID: ' + props.eventId : ''}
      </WarningText>
    </WarningContainer>
  );
};
